module.exports = __webpack_public_path__ + "static/media/phonics_04.4a84f01c.jpg";